module.exports = __webpack_public_path__ + "static/media/emptyState.6c59dab5.png";